import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/20/solid";
import { useState } from "react";

export default function HeaderSort({ title, code, sortBy, setSortBy, sortType, setSortType, children }) {
	const [isHovered, setIsHovered] = useState(false);
	return (
		<th
			style={{
				color: `${sortBy == `${code}` ? "rgb(234,97,28)" : "black"}`,
			}}
			onMouseEnter={() => setIsHovered(true)}
			onMouseLeave={() => setIsHovered(false)}
		>
			<ChevronUpIcon
				visibility={sortBy == `${code}` || (sortBy != `${code}` && isHovered) ? "visible" : "hidden"}
				style={{
					height: "1.5em",
					cursor: "pointer",
					position: "relative",
					top: `${sortType == "asc" || (isHovered && sortBy != code) ? "7px" : "5px"}`,
					transform: `${sortType == "asc" || (isHovered && sortBy != code) ? "rotateX(0deg)" : "rotateX(180deg)"}`,
				}}
				onClick={() => {
					setSortBy(code);
					if (sortBy != code) return setSortType("desc");
					setSortType(sortType == "asc" ? "desc" : "asc");
				}}
			/>
			<span
				style={{ cursor: "pointer", userSelect: "none" }}
				onClick={() => {
					setSortBy(`${code}`);
					if (sortBy == `${code}`) return setSortType(sortType == "asc" ? "desc" : "asc");
					setSortType("asc");
				}}
			>
				<span>{title}{children}</span>
			</span>
		</th>
	);
}
